import { withInstall, withNoopInstall } from '@sgui-plus/utils/with-install'
import Form from './src/form.vue'
import FormItem from './src/form-item.vue'

export const SgForm = withInstall(Form, {
  FormItem,
})

export default SgForm

export const SgFormItem = withNoopInstall(FormItem)

export * from './src/form'
export * from './src/form-item'
export * from './src/types'
export * from './src/constants'

export type FormInstance = InstanceType<typeof Form>
export type FormItemInstance = InstanceType<typeof FormItem>
